import React, { useRef, useEffect } from "react";
import AdminGroupMembersTable from "./tables/AdminGroupMembersTable";
import { useGetAdminDareyPeerGroupMembersQuery } from "store/services/adminAPI";
import { ReactComponent as CloseIcon } from "images/svg/close.svg";

const ViewGroupMembersModal = ({ showModal, id, setShowModal }) => {
  const { data, isLoading, isFetching } = useGetAdminDareyPeerGroupMembersQuery(id, {
    skip: !showModal,
  });

  const modalRef = useRef(null);

  const modalStyle = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1001,
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowModal(false);
      }
    };

    if (showModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModal, setShowModal]);

  if (!showModal) return null;

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1000,
        }}
      />
      <div className="group-members-modal" style={modalStyle} ref={modalRef}>
        <>
          <div className="filter-modal-unavailable-close">
            <CloseIcon onClick={() => setShowModal(false)} />
          </div>
          <div className="">
            <AdminGroupMembersTable
              leaderboardData={data?.data}
              isLoading={isLoading}
              isFetching = {isFetching}
            />
          </div>
        </>
      </div>
    </>
  );
};

export default ViewGroupMembersModal;